import { i18n } from "translations";
import { getMapObjectFromArray } from "utils";

import { PATemplateFieldType } from "./types";

export const PATemplateFieldTypeOptions = [
  {
    label: i18n.t("systemParameter"),
    value: PATemplateFieldType.SYSTEM,
  },
  {
    label: i18n.t("customizationParameter"),
    value: PATemplateFieldType.CUSTOM,
  },
];

export const PATemplateFieldTypeMap = getMapObjectFromArray(
  PATemplateFieldTypeOptions
);

export enum PATemplateType {
  // Nhật ký sản xuất
  PRODUCTION_LOG = "PRODUCTION_LOG",
  // Dừng máy ngoài giờ
  MACHINE_DOWNTIME = "MACHINE_DOWNTIME",
  // OT thời gian
  OT_TIME = "OT_TIME",
}

export const PATemplateTypeOptions = [
  {
    label: i18n.t("productionLog"),
    value: PATemplateType.PRODUCTION_LOG,
  },
  {
    label: i18n.t("otMachineDowntime"),
    value: PATemplateType.MACHINE_DOWNTIME,
  },
  {
    label: i18n.t("otTime"),
    value: PATemplateType.OT_TIME,
  },
];
